var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("ellipse", { transform: "rotate(-14.76 16.216 13.85)", className: styles["oc-icon-product"] || "oc-icon-product", cx: "16.2", cy: "13.9", rx: "5.3", ry: "5.3" }),
    React.createElement("ellipse", { transform: "rotate(-14.76 29.87 25.67)", className: styles["oc-icon-product"] || "oc-icon-product", cx: "29.9", cy: "25.7", rx: "3.7", ry: "3.7" }),
    React.createElement("ellipse", { transform: "rotate(-14.76 9.849 30.945)", className: styles["oc-icon-product"] || "oc-icon-product", cx: "9.8", cy: "30.9", rx: "3", ry: "3" }),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M13.9 32.6c-2.2 0-3.5-.3-3.6-.3l-.3-.1c-1-.5-1.7-2.6.4-9 2.3-7.3 5-9.4 5.1-9.5l.4-.3.5.2c.2.1 4.8 1.5 9.3 5.6 4.5 4.1 5.2 6.6 5.3 6.9l.2.6-.5.3c-.2.1-3.8 3.2-9.7 4.7-2.8.7-5.3.9-7.1.9zm-2.8-2.2c1.2.2 4.8.5 9.3-.7 4.2-1.1 7.2-3 8.4-3.9-.5-.9-1.6-2.8-4.5-5.3-3.3-3-6.7-4.5-8-5-.7.8-2.5 3.1-4.1 8.2-1.3 4.5-1.2 6.2-1.1 6.7z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Netting.svg